import { render, staticRenderFns } from "./PropertyDialog.vue?vue&type=template&id=3b0aa98b&"
import script from "./PropertyDialog.vue?vue&type=script&lang=js&"
export * from "./PropertyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports